export const BOOKSHELF_SHELF_RENDERED = 'JobcaseBookshelfShelfRendered';
export const BOOKSHELF_SHELF_ITEM_CLICKED = 'JobcaseBookshelfShelfItemClicked';
export const BOOKSHELF_ROUNDUP_ARTICLE_CLICK = 'JobcaseBookShelfRoundupArticleClick';
export const BOOKSHELF_MEDIA_TILE_CLICK = 'JobcaseBookShelfMediaTileClick';
export const SEE_MORE_CONTACTS_CLICKED = 'JobcaseSeeMoreContacts';

export const COMMUNITY_FEED_TOGGLED = 'CommunityFeedToggle';

export const CONVERSATION_CREATED = 'JobCaseConversationCreated';
export const CONVERSATION_DESTROYED = 'JobCaseConversationDestroyed';
export const CONVERSATION_UPDATED = 'JobCaseConversationUpdated';
export const CONVERSATION_UPVOTE_CREATED = 'JobCaseConversationUpvoteCreated';
export const CONVERSATION_REACTION_CREATED = 'JobCaseConversationReactionCreated';
export const CONVERSATION_UPVOTE_DESTROYED = 'JobCaseConversationUpvoteDestroyed';
export const CONVERSATION_REACTION_DESTROYED = 'JobCaseConversationReactionDestroyed';
export const CONVERSATION_UPVOTES_VIEWED = 'JobCaseViewConversationUpvotes';
export const CONVERSATION_REACTIONS_VIEWED = 'JobCaseViewConversationReactions';
export const CONVERSATION_SHARED = 'JobCaseConversationShared';
export const CONVERSATION_SHARED_FACEBOOK = 'JobCaseConversationFacebookShare';
export const CONVERSATION_SHARED_TWITTER = 'JobCaseConversationTwitterShare';
export const CONVERSATION_SHARED_COPY_LINK = 'JobCaseConversationCopyLink';
export const CONVERSATION_SUBJECT_SEE_MORE = 'JobCaseConversationSubjectSeeMore';
export const CONVERSATION_CREATE_QUALITY_GUIDELINES_SHOWN = 'JobcaseCreateQualityGuidelinesShown';
export const CONVERSATION_CREATE_QUALITY_GUIDELINES_CLOSED = 'JobcaseCreateQualityGuidelinesClosed';
export const CONVERSATION_CREATE_CLOSED = 'JobcaseCreateModalClosed';
export const CONVERSATION_CREATE_CTA_CLICKED = 'JobcaseCreateSubmitCTAButtonClicked';
export const CONVERSATION_CREATE_PICK_TARGET = 'JobcaseCreateAddGroupClicked';
export const CONVERSATION_CREATE_TEMPLATE_SHOWN = 'JobcaseCreateTemplateShown';
export const CONVERSATION_CREATE_TOGGLE_CLICKED = 'JobcaseCreateToggleClicked';
export const CONVERSATION_CREATE_INPUT_BOX_CLICKED = 'JobcaseCreateConversationInputBoxClicked';
export const CONVERSATION_CREATE_POST_CTA_CLICKED = 'JobcaseCreateConversationPostCTAClicked';
export const CONVERSATION_CREATE_QUESTION_CTA_CLICKED = 'JobcaseCreateConversationQuestionCTAClicked';
export const CONVERSATION_CREATE_PHOTO_CTA_CLICKED = 'JobcaseCreateConversationPhotoCTAClicked';
export const CONVERSATION_COMMENT_EXPAND = 'JobcaseConversationCommentBoxExpanded';
export const CONVERSATION_COMMENT_SUBMITTED = 'JobcaseConversationCommentSubmitted';
export const CONVERSATION_REPLY_SUBMITTED = 'JobcaseConversationReplySubmitted';

export const V2_CONVERSATION_CLICKED = 'JobcaseV2ConversationClicked';
export const V2_CONVERSATION_FOLLOW_INSERTED = 'JobcaseV2ConversationFollowInserted';

export const CREATE_PROFILE_PHOTO_CAMERA_ICON_CLICKED = 'JobcaseCreateProfilePhotoCameraIconClicked';
export const CREATE_PROFILE_PHOTO_UPLOAD_CTA_CLICKED = 'JobcaseCreateProfilePhotoUploadCTAClicked';
export const CREATE_PROFILE_PHOTO_UPDATED = 'JobcaseCreateProfilePhotoUpdated';

export const OPEN_CONVO_HASHTAG_CLICK = 'JobcaseOpenConvoTopicClick';

export const BAD_COMMENT_CREATED = 'JobcaseConversationBadCommentCreated';
export const GOOD_COMMENT_CREATED = 'JobcaseConversationGoodCommentCreated';
export const COMMENT_DESTROYED = 'JobCaseConversationCommentDestroyed';
export const COMMENT_UPDATED = 'JobCaseConversationCommentUpdated';
export const COMMENT_UPVOTE_CREATED = 'JobCaseConversationCommentUpvoteCreated';
export const COMMENT_REACTION_CREATED = 'JobCaseConversationCommentReactionCreated';
export const COMMENT_UPVOTE_DESTROYED = 'JobCaseConversationCommentUpvoteDestroyed';
export const COMMENT_REACTION_DESTROYED = 'JobCaseConversationCommentReactionDestroyed';
export const COMMENT_UPVOTES_VIEWED = 'JobCaseViewCommentUpvotes';
export const COMMENT_REACTIONS_VIEWED = 'JobCaseViewCommentReactions';
export const COMMENT_SHOW_MORE_CLICKED = 'CommentShowMore';

export const EXPIRED_JOB = 'BragiFetchExpiredJob';
export const EXPIRED_JOB_SEARCH = 'JobcaseExpiredJobSearch';

export const JOB_OVERLAY_RENDERED = 'job_match__modal_rendered';
export const JOB_OVERLAY_JOB_MATCH_MODAL_CLOSED = 'job_match__modal_closed';
export const JOB_OVERLAY_JOB_MATCH_MODAL_CLICKED = 'job_match__modal_clicked';

export const JOB_REMOTE_WORK_ONLY = 'JobcaseRemoteWorkOnly';
export const JOB_SORT_ORDER = 'JobcaseJobSortOrder';
export const JOB_COMPANY_SELECTED = 'JobcaseCompanyFilter';
export const JOB_SOURCE_SELECTED = 'JobcaseJobSourceFilter';
export const JOB_EXPERIENCE_SELECTED = 'JobcaseJobExperienceFilter';
export const JOB_POSTED_AT_SELECTED = 'JobcaseDatePostedFilter';
export const JOB_RADIUS_SELECTED = 'JobcaseJobLocationRadiusFilter';
export const JOB_SEARCH_CLICK = 'JobSearchClick';

export const REPLY_CREATED = 'JobcaseConversationCommentReply';
export const REPLY_UPVOTES_VIEWED = 'JobCaseViewReplyUpvotes';

export const PREVIEW_PANE_CLICK = 'openPreviewPane';
export const PREVIEW_PANE_CLOSE = 'closePreviewPane';

export const TOPIC_SHARED = 'JobCaseTopicShared';
export const TOPIC_SHARED_FACEBOOK = 'JobCaseTopicFacebookShare';
export const TOPIC_SHARED_TWITTER = 'JobCaseTopicTwitterShare';
export const TOPIC_SHARED_COPY_LINK = 'JobCaseTopicCopyLink';
export const TOPIC_FOLLOWED = 'JobcaseTopicFollowed';
export const TOPIC_UNFOLLOWED = 'JobcaseTopicUnfollowed';

export const JOB_LOCATION_UPDATED = 'JobcaseBookshelfDesiredJobLocationUpdated';
export const JOB_TITLES_UPDATED = 'JobcaseBookshelfDesiredJobTitleUpdated';

export const GROUP_SHARED = 'JobCaseGroupShared';
export const GROUP_SHARED_FACEBOOK = 'JobCaseGroupFacebookShare';
export const GROUP_SHARED_TWITTER = 'JobCaseGroupTwitterShare';
export const GROUP_SHARED_COPY_LINK = 'JobCaseGroupCopyLink';
export const GROUP_CREATED = 'JobCaseGroupCreated';
export const GROUP_INVITE_EMAIL_TRIGGERED = 'JobCaseGroupInvitationEmailTriggered';
export const GROUP_MEMBER_JOIN = 'JobcaseGroupMemberJoin';
export const GROUP_MEMBER_APPROVED_EMAIL_TRIGGERED = 'JobCaseGroupApprovedUserEmailTriggered';

export const ONBOARDING_CARD_RENDERED = 'JobcaseOnboardingCardRendered';
export const ONBOARDING_CARD_ACTION = 'JobcaseOnboardingCardAction';
export const ONBOARDING_JOB_TITLE_CARD_JOB_TITLE_CHANGES = 'JobcaseOnboardingJobTitleCardJobTitleChanges';
export const ONBOARDING_JOB_TITLE_CARD_PROFILE_UPDATE = 'JobcaseOnboardingJobTitleCardJobProfileUpdate';
export const ONBOARDING_NO_WORK_CARD_PROFILE_UPDATE = 'JobcaseOnboardingNoWorkCardProfileUpdate';
export const ONBOARDING_WITH_WORK_CARD_PROFILE_UPDATE = 'JobcaseOnboardingWithWorkCardProfileUpdate';
export const ONBOARDING_EDIT_WORK_CARD_PROFILE_UPDATE = 'JobcaseOnboardingEditWorkCardProfileUpdate';

export const SITE_NOTIFICATION_RED_DOT_SHOWN = 'JobcaseBellNotificationRedDotShown';
export const SITE_NOTIFICATION_LIST_ITEM_SHOWN = 'JobcaseBellNotificationListItemShown';
export const SITE_NOTIFICATION_LIST_ITEM_CLICKED = 'JobcaseBellNotificationListItemClicked';

export const EASY_APPLY_BUTTON_CLICKED = 'EasyApplyButtonClicked';
export const ATS_APPLY_FORM_RENDERED = 'AtsApplyFormRendered';
export const ATS_APPLY_FORM_PREPOP_FIELDS = 'AtsApplyFormPrepopulatedFields';
export const ATS_APPLY_FORM_VALIDATION_ERRORS = 'AtsApplyFormValidationErrors';
export const ATS_APPLY_FORM_SUBMIT_RESULT = 'AtsApplyFormSubmitResult';
export const ATS_APPLY_FORM_CLOSED = 'AtsApplyFormClosed';
export const ATS_APPLY_CONFIRM_BACK_TO_JOBS_CLICKED = 'AtsApplyConfirmBackToJobsClicked';
export const ATS_APPLY_CONFIRM_JOIN_JOBCASE_CLICKED = 'AtsApplyConfirmJoinJobcaseClicked';

export const GOOGLE_ONE_TAP_MODAL_SHOWN = 'GoogleOneTapModalShown';
export const GOOGLE_ONE_TAP_LOGGED_IN = 'GoogleOneTapLoggedIn';
export const GOOGLE_SIGN_IN_SHOWN = 'GoogleOneTapModalShown';
export const GOOGLE_SIGN_IN_LOGGED_IN = 'GoogleOneTapLoggedIn';

export const FEED_PAGE_LOAD = 'JobcaseFeedPageLoad';

export const CONVERSATION_MENTION_INITIATED = 'JobcaseConversationMentionInitiated';
export const COMMENT_MENTION_INITIATED = 'JobcaseConversationCommentMentionInitiated';
export const CONVERSATION_MENTION_PROFILE_SELECTED = 'JobcaseConversationMentionProfileSelected';
export const COMMENT_MENTION_PROFILE_SELECTED = 'JobcaseConversationCommentMentionProfileSelected';
export const CONVERSATION_PROFILE_MENTIONED = 'JobcaseConversationProfileMentioned';
export const COMMENT_PROFILE_MENTIONED = 'JobcaseConversationCommentProfileMentioned';

export const FEED_SUGGESTED_HUBS_CLICKED_HUB = 'JobcaseFeedSuggestedHubsClickedHub';
export const FEED_SUGGESTED_HUBS_CLICKED_FOLLOW = 'JobcaseFeedSuggestedHubsClickedFollow';
export const FEED_SUGGESTED_HUBS_CLICKED_UNFOLLOW = 'JobcaseFeedSuggestedHubsClickedUnfollow';
export const FEED_SUGGESTED_HUBS_CLICKED_SEE_MORE = 'JobcaseFeedSuggestedHubsClickedSeeMore';

export const FEED_SUGGESTED_HIRING_EVENTS_CLICKED_EVENT_CARD = 'hiring_event_community_feed_click';
export const FEED_SUGGESTED_HIRING_EVENTS_IMPRESSION = 'hiring_event_community_feed_impression';

export const REPORTABLE_PAGE_IDS = {
  FEED: '/feed',
  JOBS: '/jobs',
};

export const DISPLAY_ORDER_COMPONENT = {
  COMMUNITY_FEED: 'community_feed',
  CONVERSATION_DETAILS: 'conversation_details_page',
  FOR_YOU: 'for_you',
  CONVERSATION_SEARCH: 'conversation_search_page',
  TOPICS: 'topics',
};

export const VIEW_TYPE = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
};

// [MOPD-7234] - Registration through onboarding
export const JOB_PREFERENCES_ONBOARDING_LANDING = 'JobcaseJobPreferencesLandingClick';
export const JOB_SEARCH_LANDING_CLICK = 'JobcaseSearchLandingClick';

// [MOPD-2592] const for recent job search pills
export const RECENT_JOB_SEARCH_PILLS_CLICK = 'RecentJobSearchPillsClick';
export const RECENT_SEARCHES_PILLS_RENDERED = 'RecentJobSearchesPillsRendered';

export const REPORT_INAPPROPRIATE_CONTENT = 'reportInappropriateContent';
export const CONVERSATION_REPORTED_INAPPROPRIATE = 'JobcaseConversationReportedInappropriate';
export const COMMENT_REPORTED_INAPPROPRIATE = 'JobcaseConversationCommentReportedInappropriate';

export const REPORT_LISTING_WITH_TAGS = 'JobcaseListingsWithTags';

export const REPORT_JOB_OVERLAY_WITH_TAGS = 'JobcaseJobOverlayWithTags';
export const REPORT_JOB_OVERLAY_WITH_GHOST_TAGS = 'JobcaseJobOverlayWithGhostTags';

export const REPORT_CLICK_OUT_JOB_REDIRECT_ANIMATION_SHOWN = 'ClickOutJobRedirectAnimationShown';
export const REPORT_REDIRECTED_TO_CLICK_OUT_JOB = 'RedirectedToClickOutJob';

export const REPORT_JOB_UNIQUE_POSITION_KEY_EXPIRED = 'expired_unique_position_key';

export const REPORT_WEB_PUSH_ALLOW_CLICKED = 'client_ajax_push_notification_allow_prompt_click';
export const REPORT_WEB_PUSH_X_CLICKED = 'client_ajax_push_notification_modal_prompt_close_x';
export const REPORT_WEB_PUSH_MODAL_RENDERED = 'client_ajax_push_notification_modal_prompt_render';
export const REPORT_WEB_PUSH_NO_THANKS_CLICKED = 'client_ajax_push_notification_no_thanks_prompt_click';
export const REPORT_WEB_PUSH_ALREADY_EXISTS = 'client_ajax_push_notification_subscription_already_exists';
// Event is composed with the contents of Notification.permission when a subscription fails
export const REPORT_WEB_PUSH_SUBSCRIBE_ERROR = 'client_ajax_push_notification_permission_';
export const REPORT_WEB_PUSH_SUBSCRIPTION_PASSED = 'client_ajax_push_notification_subscription_passed';
export const REPORT_WEB_PUSH_SUBSCRIPTION_PASSED_NULL = 'client_ajax_push_notification_subscription_passed_null';
export const REPORT_WEB_PUSH_SUBSCRIBED = 'client_ajax_push_notification_subscribed';
export const REPORT_WEB_PUSH_ARRIVAL_UPDATE_SUCCESS = 'push_notification_arrival_update_success';
export const REPORT_WEB_PUSH_ARRIVAL_UPDATE_FAILURE = 'push_notification_arrival_update_failure';

export const HIRING_EVENT_CONFIRMATION_EDIT = 'JobcaseHiringEventConfirmationPageEditProfileButtonClicked';
export const HIRING_EVENT_CONFIRMATION_NOT_YOU = 'JobcaseHiringEventConfirmationPageNotMeButtonClicked';
export const HIRING_EVENT_CONVERSION = 'hiring_event_conversion_pixel';
export const HIRING_EVENT_SHARED = 'JobcaseHiringEventShared';
export const HIRING_EVENT_SHARED_FACEBOOK = 'JobcaseHiringEventFacebookShare';
export const HIRING_EVENT_SHARED_TWITTER = 'JobcaseHiringEventTwitterShare';
export const HIRING_EVENT_SHARED_COPY_LINK = 'JobcaseHiringEventCopyLink';
export const HIRING_EVENT_SHARED_JOBCASE_LINK = 'JobcaseHiringEventJobcaseLinkShare';

export const HIRING_EVENT_JOB_SEARCH_CARD_CLICK = 'JobcaseHiringEventJobSearchCardClick';
export const HIRING_EVENT_JOB_SEARCH_CARD_IMPRESSION = 'JobcaseHiringEventJobSearchCardImpression';
export const HIRING_EVENT_REGISTRATION_START = 'JobcaseHiringEventRegistrationStart';
export const HIRING_EVENT_REGISTRATION_COMPLETE = 'JobcaseHiringEventRegistrationComplete';

/**
 * Profile Reporting
 */

export const PROFILE_EVENTS = {
  JOBCASE_PROFILE_VIEW_EVENT: 'JobcaseReactProfileViewed',
  JOBCASE_PROFILE_BIO_UPDATED: 'JobcaseReactProfileUpdatedBio',
  JOBCASE_PROFILE_PROFILE_PICTURE_UPDATED: 'JobcaseReactProfileUpdatedProfilePicture',
  JOBCASE_PROFILE_ATTRIBUTE_MODIFIED: 'JobcaseReactProfileAttributeModified',
  JOBCASE_PROFILE_COMPONENT_CLICKED: 'JobcaseReactProfileComponentClicked',
  JOBCASE_PROFILE_FOLLOW_ACTION: 'JobcaseReactProfileFollowAction',
  JOBCASE_PROFILE_PRAISE_CREATED: 'JobcaseReactProfilePraiseCreated',
  JOBCASE_PROFILE_PRAISE_RECEIVED: 'JobcaseReactProfilePraiseReceived',
  JOBCASE_PROFILE_PRAISE_VISIBILITY_MODIFIED: 'JobcaseReactProfilePraiseVisibilityModified',
  JOBCASE_PROFILE_PRAISE_MODIFIED: 'JobcaseReactProfilePraiseModified',
  JOBCASE_PROFILE_RESUME_UPLOADED: 'JobcaseReactProfileResumeUploaded',
  JOBCASE_PROFILE_RESUME_DELETED: 'JobcaseReactProfileResumeDeleted',
  JOBCASE_PROFILE_REPORTED: 'JobcaseReactProfileReported',
  JOBCASE_PROFILE_ACTIVITY_FILTER: 'JobcaseReactProfileActivityFilter',
  JOBCASE_PROFILE_FOLLOW_CLICKED: 'JobcaseProfileFollowClicked',
  JOBCASE_PROFILE_CONNECT_CLICKED: 'JobcaseProfileConnectClicked',
  JOBCASE_PROFILE_COMPLETION_PROMPT_DISPLAYED: 'JobcaseProfileCompletionPromptDisplayed',
  JOBCASE_PROFILE_COMPLETION_PROMPT_CLICKED: 'JobcaseProfileCompletionPromptClicked',
  JOBCASE_PROFILE_COMPLETION_TEST_TOOLTIP_VIEWED: 'JobcaseProfileCompletionTestTooltipViewed',
  JOBCASE_CANDIDATE_PROFILE_VIEW_EVENT: 'JobcaseJobCandidateProfileViewed',
};

/**
 * Connections Reportable Events
 */

export const CONNECTIONS_EVENTS = {
  JOBCASE_CONNECTION_REQUESTED: 'JobcaseConnectionRequested',
  JOBCASE_CONNECTION_REQUEST_DISPOSITIONED: 'JobcaseConnectionRequestDispositioned',
  JOBCASE_CONNECTION_REQUEST_DISPOSITIONED_REDIRECT: 'JobcaseConnectionRequestDispositionedRedirect',
  JOBCASE_CONNECTION_DISCONNECTED: 'JobcaseConnectionDisconnected',
};

/**
 * Recommendations Reportable Events
 */

export const RECOMMENDATIONS_EVENTS = {
  JOBCASE_FEED_CONNECTIONS_SHELF_RENDERED: 'JobcaseFeedConnectionsShelfRendered',
  JOBCASE_FEED_CONNECTIONS_SHELF_CONNECT: 'JobcaseFeedConnectionsShelfConnect',
  JOBCASE_FEED_CONNECTIONS_SHELF_REMOVE_X: 'JobcaseFeedConnectionsShelfRemoveX',
  JOBCASE_FEED_CONNECTIONS_SHELF_FIND_MORE_FRIENDS_CTA_CLICKED: 'JobcaseFeedConnectionsShelfFindMoreFriendsCTAClicked',
};

/**
 * Company Hubs Reportable Events
 */

export const COMPANY_HUB_FOLLOWED = 'JobcaseCompanyHubFollowed';
export const COMPANY_HUB_UNFOLLOWED = 'JobcaseCompanyHubUnfollowed';
export const HIRING_EVENT_CLICKED = 'JobcaseCompanyHubPageClick';

export const ARTICLE_BODY_LINK_CLICKED = 'JobcaseArticleBodyLinkClicked';
export const ARTICLE_PAGE_CLICKED = 'JobcaseArticlePageClick';

export const PEOPLE_DISCOVERY_CONTACTS_SHOWN = 'ContactsShown';
export const PEOPLE_DISCOVERY_FIND_CONTACTS_BUTTON_CLICKED = 'FindContactButtonClicked';
export const PEOPLE_DISCOVERY_IMPORT_CONTACTS_CLICKED = 'ImportContactsClicked';
export const PEOPLE_DISCOVERY_INVITE_BUTTON_CLICKED = 'InviteButtonClicked';
export const PEOPLE_DISCOVERY_PAGE_VIEW = 'PeopleDiscoveryPageViewEvent';
export const PEOPLE_DISCOVERY_SUGGESTED_CONTACTS_LOADED = 'SuggestedContactsLoaded';
export const PEOPLE_DISCOVERY_GMAIL_CONTACTS_RETURNED = 'GmailContactsReturned';
export const PEOPLE_DISCOVERY_GMAIL_IMPORT_FAILED = 'GmailContactImportFailed';
export const PEOPLE_DISCOVERY_ACCESS_DENIED = 'GmailContactAccessDeclined';

/**
 * Hiring Event Reportable Events
 */
export const HIRING_EVENT_PROMO_SHOW = 'HiringEventPromoShow';
export const HIRING_EVENT_PROMO_CLICK = 'HiringEventPromoClicked';
export const HIRING_EVENT_PROMO_CLOSE = 'HiringEventPromoClosed';
export const HIRING_EVENT_LOCATION_HYPERLINK_CLICKED = 'HiringEventLocationHyperlinkClicked';
export const HIRING_EVENT_RELATED_EVENT_CLICKED = 'HiringEventRelatedEventClicked';
export const HIRING_EVENT_RELATED_EVENT_CLICKED_SEE_ALL = 'HiringEventRelatedEventClickedSeeAll';
export const HIRING_EVENT_HUB_LOGO_CLICK = 'HiringEventHubLogoClick';
export const HIRING_EVENT_HUB_NAME_CLICK = 'HiringEventHubNameClick';
export const HIRING_EVENT_JOBS_NAV_CLICKED = 'HiringEventJobsNavClicked';
export const HIRING_EVENT_PREPARATION_NAV_CLICKED = 'HiringEventPreparationNavClicked';
export const HIRING_EVENT_SMS_OPT_IN_STATUS = 'HiringEventSmsOptInStatus';
export const HIRING_EVENT_REGISTRATION_MODAL_RENDERED = 'HiringEventRegistrationModalRendered';
export const HIRING_EVENT_ADD_TO_CALENDAR_CLICKED_OPTION = 'HiringEventAddToCalendarClickedOption';
export const HIRING_EVENT_ADD_TO_CALENDAR_CLICKED = 'HiringEventAddToCalendarClicked';
export const HIRING_EVENT_SEARCH_CLICK = 'JobcaseEventSearchClick';

// Onboarding
export const ONBOARDING_TOASTER_CLOSE_X = 'JobcaseOnboardingToasterCloseX';
export const ONBOARDING_TOASTER_SEE_MORE = 'JobcaseOnboardingToasterSeeMore';

// Phenom
export const PHENOM_CARD_RENDERED = 'JobcasePhenomCTACardRendered';
export const PHENOM_CARD_STARTED_FLOW = 'JobcasePhenomCTACardStartedFlow';
export const PHENOM_CARD_STEP_COMPLETE = 'JobcasePhenomCTACardStepComplete';

// SMS Opt In Modal
export const MEMBER_APP_SMS_OPT_IN_JOB_SEARCH = 'member-app-sms-opt-in-job-search';
export const SMS_OPT_IN_MODAL_RENDERED = 'SmsOptInModalRendered';
export const SMS_OPT_IN_MODAL_OPT_IN_SUCCESS = 'SmsOptInModalOptInSuccess';
export const SMS_OPT_IN_MODAL_OPT_IN_ERROR = 'SmsOptInModalOptInError';
export const SMS_OPT_IN_MODAL_CLICKED_HAVE_ACCOUNT = 'SmsOptInModalClickedHaveAccount';
export const SMS_OPT_IN_MODAL_CLOSED = 'SmsOptInModalClosed';
export const SMS_OPT_IN_CHANGE_NUMBER_OPT_OUT = 'SmsChangeNumberAndOptOut';
export const SMS_OPT_OUT_IN_SETTING = 'SmsOptOutInSettings';
export const SMS_OPT_IN_AP_ERROR = 'SmsOptInActiveProspectError';
export const SMS_OPT_IN_NOTIFICATION_CLICKED = 'SmsOptInNotificationClicked';
export const SMS_OPT_IN_MISMATCHED_NUMBER = 'SmsOptInMismatchedNumber';
export const SMS_OPT_IN_MODAL_SUPPRESSED = 'SmsOptInModalSuppressed';

// SMS Opt In Nudge Card
export const SMS_OPT_IN_NUDGE_RENDERED = 'SmsOptInNudgeCardRendered';
export const SMS_OPT_IN_NUDGE_CLICKED = 'SmsOptInNudgeCardClicked';
export const SMS_OPT_IN_NUDGE_VIEWED = 'SmsOptInNudgeCardViewed';

// SSO
export const JOBCASE_SSO_VIEW_RENDERED = 'JobcaseSsoViewRendered';
export const JOBCASE_CREATE_ACC_NATIVE_AUTH_CLICKED = 'JobcaseCreateAccNativeAuthClick';
export const JOBCASE_CREATE_ACC_NATIVE_AUTH_ERROR = 'JobcaseCreateAccNativeAuthError';
export const JOBCASE_LOGIN_NATIVE_AUTH_CLICK = 'JobcaseLoginNativeAuthClick';
export const JOBCASE_LOGIN_NATIVE_AUTH_ERROR = 'JobcaseLoginNativeAuthError';
export const JOBCASE_SSO_LOGIN = 'JobcaseSsoLogin';
/**
 * Work From Home Page Reportable Events
 */
export const WORK_FROM_HOME_EVENTS = {
  JOBCASE_WORK_FROM_HOME_JOIN_CLICK: 'JobcaseWorkFromHomeJoinClick',
  JOBCASE_WORK_FROM_HOME_EXPLORE_JOBS_CLICK: 'JobcaseWorkFromHomeExploreJobsClick',
  JOBCASE_WORK_FROM_HOME_EXPLORE_COMMUNITY_CLICK: 'JobcaseWorkFromHomeExploreCommunityClick',
  JOBCASE_WORK_FROM_HOME_START_PROFILE_CLICK: 'JobcaseWorkFromHomeStartProfileClick',
  JOBCASE_WORK_FROM_HOME_START_APPLYING_CLICK: 'JobcaseWorkFromHomeApplyInstantlyClick',
  JOBCASE_WORK_FROM_HOME_UNKNOWN_CLICK: 'JobcaseWorkFromHomeUnknownClick',
};

// Session Events
export const TIME_SPENT = 'TimeSpent';
export const SCROLL_DEPTH = 'ScrollDepth';

// Direct Messaging Events
export const MESSAGE_SENT = 'JobcaseMessageSent';
export const MESSAGE_READ = 'JobcaseMessageRead';
export const MESSAGE_INPUT_CLICKED = 'JobcaseCreateMessageModalOpened';

// Employer Onboarding
export const EMPLOYER_ONBOARDING_ARRIVED_CREATE_ACCOUNT = 'EmployerOnboardingArrivedCreateAccount';
export const EMPLOYER_ONBOARDING_LOGGED_IN = 'EmployerOnboardingLoggedIn';
export const EMPLOYER_ONBOARDING_ACCOUNT_CREATED = 'EmployerOnboardingAccountCreated';
export const EMPLOYER_ONBOARDING_EXIT_CREATE_ACCOUNT = 'EmployerOnboardingExitCreateAccount';
export const EMPLOYER_ONBOARDING_ARRIVED_ACCOUNT_DETAILS = 'EmployerOnboardingArrivedAccountDetails';
export const EMPLOYER_ONBOARDING_SUBMIT_ACCOUNT_DETAILS = 'EmployerOnboardingSubmitAccountDetails';
export const EMPLOYER_ONBOARDING_EXIT_ACCOUNT_DETAILS = 'EmployerOnboardingExitAccountDetails';
export const EMPLOYER_ONBOARDING_EXIT_SELECT_SERVICES = 'EmployerOnboardingExitSelectServices';
export const EMPLOYER_ONBOARDING_CONTINE_TO_EMPLOYER_CENTER = 'EmployerOnboardingContinueToEmployerCenter';
export const EMPLOYER_ONBOARDING_EXIT_CONFIRMATION = 'EmployerOnboardingExitConfirmation';
